import type { LineItemForm } from '../../../pages/Campaigns/Form/types';

export const hasAdvancedDeliveryControls = (values: LineItemForm): boolean => {
  const hasDayparting = values.dayParting?.some((row) => row?.activeDayList?.some(Boolean));
  const hasScheduledPacing = (values.pacingSchedules?.length ?? 0) > 0;
  const hasFrequencyCap = Boolean(values.frequency) && Boolean(values.frequencyCapUnit);

  return Boolean(hasDayparting || hasScheduledPacing || hasFrequencyCap);
};
